import { render, staticRenderFns } from "./moduleMain.vue?vue&type=template&id=fbd7ecec"
import script from "./moduleMain.vue?vue&type=script&lang=js"
export * from "./moduleMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports